import { Link } from 'found'
import { Helmet } from 'react-helmet'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 
import { MarkerWithLabel } from 'react-google-maps/lib/components/addons/MarkerWithLabel'
import LazyLoad from 'react-lazy-load'

import GMaps from '../../components/map'

import Article from '../home-page/article'
// import RecentSection from './recent-section'

import MapStyle from './map-style'

import genericInteriorImage from '../../images/generic-nterior2.png'
// import imagePlacePlaceholder from '../../images/image-4-3-placeholder.svg'
import imagePlaceholder from '../../images/image-1-1-placeholder.svg'
import imageSearchIcon from '../../images/search_1.svg'
import imageDropdownIcon from '../../images/Artboard-41-copy-2.svg'
// import imagePostPlaceholder from '../../images/image-19-9-placeholder.svg'
// import imageBookCover from '../../images/berlinbook.svg'
// import imageBookOpened500w from '../../images/berlin_int-p-500.png'
// import imageBookOpened800w from '../../images/berlin_int-p-800.png'
// import imageBookOpened1080w from '../../images/berlin_int-p-1080.png'
// import imageBookOpened1785w from '../../images/berlin_int.png'
import imageGreyTimeIcon from '../../images/grey_time.svg'
import imagePlaceIcon from '../../images/place.svg'
// import imageIncubatorMarkerIcon from '../../images/locationsincubators.svg'
// import imageCoworkingMarkerIcon from '../../images/locationscowork.svg'
// import imageCoffeeMarkerIcon from '../../images/locationscoffeeshops.svg'
// import imageChevronRight from '../../images/chevron-right.svg'

class CityPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            placeCategories: [],
            placeHover: [],
        }
    }

    componentDidMount()
    {
        // Forces Webflow animations to load
        setTimeout(()=>{
            window.Webflow && window.Webflow.destroy();
            window.Webflow && window.Webflow.ready();
            window.Webflow && window.Webflow.require( 'ix2' ).init();
        },500)
    }

    componentDidUpdate()
    {
        console.log('contador')
        setTimeout(()=>{
            window.Webflow && window.Webflow.destroy();
            window.Webflow && window.Webflow.ready();
            window.Webflow && window.Webflow.require( 'ix2' ).init();
        },500)
    }

    handleMapReady = (api) => {
        this.setState({ placeService: new window.google.maps.places.PlacesService(api) }, this.loadMap)
    }

    loadMap() {
        const { placeService } = this.state
        if (!placeService) {
            return
        }

        let request = {
            placeId: '',
            fields: [ 'name', 'photos', 'geometry', 'url' ]
        }

        let placeCategories =
            this.props.city.map.placeCategories.map(category => {
                let places = category.places.map(propPlace => {
                    let place = {
                        name: propPlace.name,
                        picture: propPlace.picture,
                        location: {
                            lat: propPlace.location.latitude,
                            lng: propPlace.location.longitude,
                        }
                    }

                    request.placeId = propPlace.placeId

                    let promise = new Promise((resolve, reject) => {
                        placeService.getDetails(request, async (gmapPlace, status) => {
                            if (!gmapPlace || !gmapPlace.geometry) {
                                console.log(status)
                                resolve(place)
                                return
                            }

                            // FIXME: make this call sync with the caller
                            // FIXME: quota problem? the field isn't already present
                            // place.thumbnail = gmapPlace.photos[0].getUrl()
                            place.location = {
                                lat: gmapPlace.geometry.location.lat(),
                                lng: gmapPlace.geometry.location.lng()
                            }
                            place.url = gmapPlace.url
                            resolve(place)
                        })
                    })

                    return promise
                })
                return {
                    name: category.name,
                    markerIcon: category.markerIcon,
                    places
                }
            })
        Promise.all(
            placeCategories.map(async c =>
                await Promise.all(c.places).then(places => ({ ...c, places }))
            )
        ).then(placeCategories => this.setState({ placeCategories }))
    }

    onHover = (isHover, name) => {
        this.setState({ [name]: isHover })
    }

    onClick = (name) => {
        this.setState({ [name]: (this.state[name] === undefined ? true : !this.state[name]) })
    }

    isHover = (name) => {
        // console.log(this.state[name])
        return this.state[name]
    }

    render() {
        const { routeResolver } = this.props.context
        let hasArticles = this.props.city.articles.length > 0
        let hasBook = this.props.city.products.length > 0
        let hasEvents = this.props.city.events.length > 0
        let hasPlaces = this.props.city.map.placeCategories.length > 0
        let seo = this.props.city.seo;
        let generic = this.props.city.social.generic[0];
        let twitter = this.props.city.social.twitter[0];

        // var blockLazy = (/blocklazy/gi).test(window.location.href);
        var recentArticles = this.props.city.articles.map(a => ({
            ...a,
            link: routeResolver.article.get(this.props.city.slug, a.slug),
        }))
        
        recentArticles.sort((a,b)=> {
            if (new Date(a.publishedAt) > new Date(b.publishedAt))
                return -1;
              if (new Date(a.publishedAt) < new Date(b.publishedAt))
                return 1;
              return 0;
        })
        
        const products = this.props.city.products.map(p => ({
            ...p,
            link: routeResolver.product.get(p.slug),
        }))

        return (
            <div>
                <Helmet>
                    <title>Startup Guide - {seo.title?seo.title:this.props.city.name}</title>
                    <meta content={seo.description?seo.description:this.props.city.caption} name="description" />

                    <meta content="website" property="og:type" />
                    <meta content={generic&&generic.title?generic.title:this.props.city.name} property="og:title" />
                    <meta content={generic&&generic.description?generic.description:this.props.city.caption} property="og:description" />
                    <meta content={generic&&generic.image?generic.image:this.props.city.picture} property="og:image" />
                    <meta property="og:url" content={"https://startupguide.com/cities/"+this.props.city.slug}></meta>
                    <meta property="og:site_name" content="StartupGuide"></meta>

                    <meta name="twitter:card" content={twitter&&twitter.type.includes('Standard')?'summary':'summary_large_image'}></meta>
                    <meta name="twitter:site" content="@StartupGuideHQ"></meta>
                    <meta name="twitter:creator" content={twitter&&twitter.handle?twitter.handle:'@StartupGuideHQ'}></meta>
                    <meta name="twitter:title" content={twitter&&twitter.title?twitter.title:this.props.city.name}></meta>
                    <meta name="twitter:description" content={twitter&&twitter.description?twitter.description:this.props.city.caption}></meta>
                    <meta name="twitter:image" content={twitter&&twitter.image?twitter.image:this.props.city.picture}></meta>
                </Helmet>
                <TopCityMenuBar city={this.props.city} related={this.props.city.related} context={this.props.context} >
                    {hasArticles && <a href="#recent-posts" className="internal-page-link berlin" style={{ color: this.props.city.color, borderColor: this.props.city.color }}>Recent Articles</a>}
                    {hasBook && <a href="#city-book" className="internal-page-link berlin" style={{ color: this.props.city.color, borderColor: this.props.city.color }}>Book</a>}
                    {hasEvents && <a href="#events" className="internal-page-link berlin" style={{ color: this.props.city.color, borderColor: this.props.city.color }}>Events</a>}
                    {hasPlaces && <a href="#map" className="internal-page-link berlin" style={{ color: this.props.city.color, borderColor: this.props.city.color }}>Map</a>}
                </TopCityMenuBar>
                {hasArticles &&
                    <RecentArticles articles={recentArticles} city={this.props.city} />
                }
                {hasBook &&
                    <Book book={products[0]} />
                }
                {hasEvents &&
                    <Events events={this.props.city.events} />
                }
                <div id="events" className="events"></div>
                {hasPlaces &&
                    <Map key={this.props.city.slug} city={this.props.city} {...this.props.city.map} onReady={this.handleMapReady} placeCategories={this.state.placeCategories} onClick={this.onClick} onHover={this.onHover} isHover={this.isHover} />
                }
            </div>
        )
    }
}

class TopCityMenuBar extends Component {

    constructor() {
        super()
        this.state = { isDropdownOpen: false }
    }

    render() {
        const { context, city, related, children } = this.props
        return (
            <div>
                <div data-w-id="fb3862d7-e657-b819-ef85-b87e4b222671" style={{ opacity: 0}} className="city-scrollbar berlin">
                    <div className="links-container top-bar w-hidden-small w-hidden-tiny">
                        <img alt="" src={imagePlaceholder} width="27" className="image-47" />
                        <div className="div-block-61">
                            <div className="text-block-60">LOCATION: </div>
                            <div className="text-block-61">{city.name}</div>
                        </div>
                        <div className="div-block-60">
                            {children}
                        </div>
                        <img alt="" src={imageSearchIcon} width="24" className="image-49" />
                    </div>
                </div>
                <div className="section-6">
                    <div className="div-block-43" style={{background: city.color}}>
                        <div className="cities-selector">
                            <div className="text-block-41">LOCATION</div>
                            <div data-delay="0" className="dropdown w-dropdown">
                                <div
                                    className="city-selector-dropdown w-dropdown-toggle"
                                    onMouseEnter={() => this.setState({ isDropdownOpen: true })}
                                    onMouseLeave={() => this.setState({ isDropdownOpen: false })}
                                >
                                    <div className="text-block-5">{city.name}</div>
                                    <img alt="" src={imageDropdownIcon} width="19" className="image-34" />
                                </div>
                                <nav
                                    className="dropdown-list-3 w-dropdown-list"
                                    onMouseEnter={() => this.setState({ isDropdownOpen: true })}
                                    onMouseLeave={() => this.setState({ isDropdownOpen: false })}
                                    style={{ display: this.state.isDropdownOpen ? 'block' : 'none' }}
                                >
                                    <div className="text-block-106">Related Locations:</div>
                                    {related.map(c => (
                                        <Link
                                            key={c.slug}
                                            to={context.routeResolver.location.get(c.slug)}
                                            className="cities-dropdown-link w-dropdown-link"
                                        >
                                            {c.name}
                                        </Link>
                                    ))}
                                    <Link
                                        to={context.routeResolver.locations.get()}
                                        className="cities-dropdown-link w-dropdown-link"
                                    >
                                        See all cities
                                    </Link>
                                </nav>
                            </div>
                        </div>
                        <div className="div-block-164" style={{ backgroundImage: 'url(' + city.headerPicture + ')' }} />
                    </div>
                </div>

                <div className="page-heading">
                    <div className="berlin-row w-hidden-small w-hidden-tiny">
                        <div className="city-content-navigation w-hidden-tiny">
                            <div className="links-container">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class RecentArticles extends Component {

    constructor() {
        super()
        this.state = { rows: 2, isHoverDiscoverMore: false }
    }
    render() {
        const { articles, city } = this.props
        const canLoadMore = articles.length > this.state.rows * 4
        return (
            <div>
                <div id="recent-posts" className="recent-city-posts">
                    <div className="berlin-row">
                        {Array(this.state.rows).fill().map((_, r) =>
                            <div key={r} className="row-berlin w-row">
                                {articles.slice(4 * r, 4 * r + 4).map((a, k) =>
                                    <Article key={k} {...a} hideGroupName={true} small={true} city={a.city || city} />
                                )}
                            </div>
                        )}
                    </div>
                    <div className="discover-berlin w-container">
                        <a
                            className="discover-more-category busines w-button"
                            style={{
                                display: canLoadMore ? 'block' : 'none',
                                borderColor: city.color,
                                background: this.state.isHoverDiscoverMore ? '#ffffff' : city.color,
                                color: this.state.isHoverDiscoverMore ? city.color : '#ffffff',
                            }}
                            onClick={() => this.setState({ rows: this.state.rows + 1 })}
                            onMouseEnter={() => this.setState({ isHoverDiscoverMore: true })}
                            onMouseLeave={() => this.setState({ isHoverDiscoverMore: false })}
                        >
                            DISCOVER&nbsp;MORE
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

const Events = ({events}) => (
    <div id="events" className="events">
        <div className="berlin-row-events">
            <h1 className="section-headline-big margin-bottom-32px">EVENTS</h1>
            <div className="events-row w-row">
                {events.map(event => (<Event key={event.slug} {...event} />))}
            </div>
            <div className="buttons-container centered">
                <a className="discover-more-events berlin w-button">
                    MORE EVENTS IN BERLIN
                </a>
            </div>
        </div>
    </div>
)

// Format given date to English format, and to user's timezone.
function formatDate(date) {
    let dayStr = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
    let monthStr = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]

    let hour = date.getHours()
    let xm
    if (hour >= 12) {
        xm = 'pm'
        hour -= 12
    }
    else
        xm = 'am'

    let minutes = date.getMinutes()
    if (minutes < 10) {
        minutes  = '0' + minutes
    }

    return `${dayStr[date.getDay()]}, ${monthStr[date.getMonth()]} ${date.getDate()}, ${hour}:${minutes} ${xm}`
}

const Event = (event) => {
    let price
    if (event.price.fix) {
        price = event.price.fix.price > 0
                                      ? `${event.price.fix.currency}${event.price.fix.price}`
                                      : 'Free'
    } else if (event.price.range) {
        let range = event.price.range
        if (range.to === 0) {
            price = `From ${range.currency}${range.from}`
        } else {
            price = `${range.currency}${range.from} - ${range.currency}${range.to}`
        }
    }

    let date = new Date(event.date)
    let day = date.getDate()
    let month = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'][date.getMonth()]
    let formatedDate = formatDate(date)

    return (
        <div className="column-5 w-col w-col-3 w-col-medium-6">
            <div>
                <div className="event-image">
                    <div className="event-price nested">
                        <div className="category-name">{price}</div>
                    </div>
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <img alt="" src={event.thumbnail} className="image-event" />
                    </LazyLoad>
                </div>
                <div className="w-row">
                    <div className="w-col w-col-3">
                        <div className="div-block-44">
                            <h5 className="event-date-time margin-top-16px margin-bottom-8px">{month}<br/></h5>
                            <h5 className="event_day">{day}<br/></h5>
                        </div>
                    </div>
                    <div className="w-col w-col-9">
                        <h3 className="event-title">{event.title}</h3>
                        <div className="div-block-45">
                            <LazyLoad offsetVertical={100} debounce={false}>
                                <img alt="" src={imageGreyTimeIcon} width="16" className="image-36" />
                            </LazyLoad>
                            <div className="place">{formatedDate}</div>
                        </div>
                        <div className="div-block-45">
                            <LazyLoad offsetVertical={100} debounce={false}>                            
                                <img alt="" src={imagePlaceIcon} width="14" className="location" />
                            </LazyLoad>
                            <div className="place">{event.location.name}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Book = ({ book }) => (
    <div id="city-book" className="city-book">
        <div className="berlin-row-book">
            <div className="row-8 w-row">
                <div className="column-13 w-col w-col-5 img-container">
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <img alt="" src={book.picture} width="323" className="image-39" />
                    </LazyLoad>
                    <LazyLoad offsetVertical={100} debounce={false}>
                        <img alt="" src={genericInteriorImage} width="563" className="image-38 w-hidden-medium w-hidden-small w-hidden-tiny" />
                    </LazyLoad>                       
                </div>
                <div className="column-14 w-col w-col-7">
                    <h2 className="heading-26">{book.name}</h2>
                    <p className="paragraph-normal margin-bottom-32px">{book.summary}</p>
                    <Link to={book.link} className="buy-the-book w-button">BUY THE BOOK</Link>
                </div>
            </div>
        </div>
    </div>
)

const Map = (props) => {
    let places = props.placeCategories.map((category, k) =>
        <Places
                key={k}
                {...category}
                onClick={props.onClick}
                onHover={props.onHover}
                googleMapURL="https://maps.googleapis.com/maps/api/staticmap?key=AIzaSyDuOuk9wVDoruQKsoWfJ-fhr5P6MRkwPM4&center=39.10624324476573,-4.555226245627864&zoom=7&format=png&maptype=roadmap&style=element:geometry.fill%7Ccolor:0xf2eeeb&style=element:geometry.stroke%7Ccolor:0xcfcbc9%7Cvisibility:off&style=element:labels.icon%7Cvisibility:off&style=element:labels.text%7Cvisibility:on&style=element:labels.text.fill%7Ccolor:0xa19d9c%7Cvisibility:on&style=element:labels.text.stroke%7Cvisibility:off&style=feature:administrative.land_parcel%7Cvisibility:off&style=feature:administrative.land_parcel%7Celement:geometry.fill%7Cvisibility:off&style=feature:administrative.neighborhood%7Cvisibility:off&style=feature:administrative.neighborhood%7Celement:geometry.fill%7Cvisibility:off&style=feature:poi%7Celement:labels.text%7Cvisibility:off&style=feature:poi.business%7Cvisibility:off&style=feature:road%7Celement:geometry.fill%7Ccolor:0xe8e3e1%7Cvisibility:on&style=feature:road%7Celement:labels%7Cvisibility:off&style=feature:road%7Celement:labels.icon%7Cvisibility:off&style=feature:transit%7Cvisibility:off&style=feature:water%7Celement:geometry.fill%7Ccolor:0xfcfcfb%7Cvisibility:on&style=feature:water%7Celement:geometry.stroke%7Cvisibility:off&style=feature:water%7Celement:labels.icon%7Cvisibility:off&style=feature:water%7Celement:labels.text%7Cvisibility:simplified&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x000000&style=feature:water%7Celement:labels.text.stroke%7Cvisibility:off&size=480x360"
                loadingElement={<div style={{ height: `100%` }} />}
        />
    )

    return (
        <div id="map" className="event-map">
            <h1 className="section-headline-big-mobile margin-bottom-16px map w-hidden-main w-hidden-medium">
                EXPLORE {props.city.name}
            </h1>
            <div className="row-20 w-row">
                <div className="column-15 w-col w-col-8 w-col-medium-6">
                    <div className="map-container">
                        <div className="map-2 w-widget w-widget-map">
                            <GMaps
                                defaultOptions={{ styles: MapStyle }}
                                defaultZoom={12}
                                defaultCenter={{
                                    lat: props.defaultCenter.latitude,
                                    lng: props.defaultCenter.longitude
                                }}
                                onReady={props.onReady}
                            >
                                {props.placeCategories.map(c =>
                                    c.places.map((p, k) => p && p.location &&
                                        <MarkerWithLabel
                                            key={k}
                                            position={p.location}
                                            onClick={() => props.onClick(p.name)}
                                            onMouseOver={() => props.onHover(true, p.name)}
                                            onMouseOut={() => props.onHover(false, p.name)}
                                            icon={{
                                                url: c.markerIcon,
                                                scaledSize: { width: 32, height: 39 },
                                                anchor: { x: 8, y: 17 },
                                                strokeColor: '#F68B21',
                                            }}
                                            labelAnchor={{ x: -10, y: 35 }}
                                            labelStyle={{
                                                width: props.isHover(p.name) ? 'auto' : '0',
                                                height: props.isHover(p.name) ? 'auto' : '0',
                                                padding: props.isHover(p.name) ? '0.7em' : '0',
                                                backgroundColor: '#ffffff',
                                                color: '#555'
                                            }}
                                        >
                                            <div>{p.name}</div>
                                        </MarkerWithLabel>
                                    )
                                )}
                            </GMaps>
                        </div>
                    </div>
                </div>
                <div className="column-16 w-col w-col-4 w-col-medium-6 w-col-small-small-stack">
                    <div className="map-legend-container">
                        <h1
                            className="section-headline-big margin-bottom-16px map w-hidden-small w-hidden-tiny"
                            style={{ textTransform: 'uppercase' }}
                        >
                            EXPLORE {props.city.name}
                        </h1>
                        <div className="scrollable-container">
                            {places}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Places = (props) => {
    let nbPerRow = 3
    let places = []
    for (let i = 0; i < props.places.length / nbPerRow; ++i) {
        let begin = i * nbPerRow
        let end = begin + nbPerRow
        let row = props.places.slice(begin, end).map((place, k) =>
            place &&
                <Place key={k} query={place} onHover={props.onHover} onClick={props.onClick} />
        )
        places.push(<div className="w-row" key={i}>{row}</div>)
    }

    return (
        <div className="legend-incubators">
            <div className="location-header w-clearfix">
                <img alt="" src={props.markerIcon} width="24" height="24" className="location-pin-icon"/>
                <h4 className="section-headline-small">{props.name}</h4>
                { /* TODO: load more
                <a href="#" className="button link icon-right link-block w-inline-block w-clearfix">
                    <div className="text-block">See all</div>
                    <img alt="" src={imageChevronRight} height="16" width="16" className="icon _16px black" />
                </a>
                */ }
            </div>
            <div className="featured-spaces">
                {places}
            </div>
        </div>
    )
}


const Place = (props) => {
    // MAGIC FORMULA: max(min(elWidth/(10*multiplier),settingMax),settingMin)
    let elRef = React.createRef();
    let titleRef = React.createRef();

    function calcFontSize(){
        let size = Math.max(Math.min(elRef.current.clientWidth / 7.5, 22), 10) + 'px';
        titleRef.current.style.fontSize = size;
    }

    return (
        <div className="w-col w-col-4" ref={elRef} onLoad={calcFontSize}>
            <div
                className="city-location-middle-column"
                onMouseEnter={() => props.onHover(true, props.query.name)}
                onMouseLeave={() => props.onHover(false, props.query.name)}
                onClick={() => props.onClick(props.query.name)}
            >
                <img alt="" src={props.query.picture} />
                <h3 ref={titleRef} className="city-location-title margin-top-8px">{props.query.name}</h3>
            </div>
        </div>
    )
}

export default createFragmentContainer(
    CityPage,
    graphql`
        fragment cityPage_city on City {
            slug
            name
            caption
            color
            picture
            headerPicture
            seo {
                title
                description
            }
            social {
                twitter {
                    type
                    title
                    image
                    handle
                    description
                }
                generic {
                    title
                    image
                    description
                }
            }
            articles(first:1000) {
                slug
                title
                readingTime
                picture
                caption
                city {
                    slug
                    color
                    name
                }
                author {
                    firstname
                    lastname
                }
                publishedAt
            }
            products {
                slug
                name
                summary
                picture
                preview
            }
            events {
                slug
            }
            map {
                defaultCenter {
                    latitude
                    longitude
                }
                placeCategories {
                    name
                    markerIcon
                    places {
                        name
                        picture
                        placeId
                        location {
                            latitude
                            longitude
                        }
                    }
                }
            }
            related {
                slug
                name
                caption
            }
        }
    `
)
